export default function CustomAlertModal({ status, title, onClose }) {
  if (!status) return null;

  return (
    <div className="custom-alert-backdrop">
      <div className="custom-alert-modal">
        <h3 className="custom-alert-title">ℹ️ Info</h3>
        <p className="custom-alert-message">{title}</p>
        <button className="custom-alert-button" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
}
